import { useState } from "react";
import { RecordsTab } from "../../components/admin/attendance/RecordsTab";
import { RegularizationsTab } from "../../components/admin/attendance/RegularizationsTab";
import { HolidaysTab } from "../../components/admin/attendance/HolidaysTab";
import { ShiftsTab } from "../../components/admin/attendance/ShiftsTab";
import { CalendarTab } from "../../components/admin/attendance/CalendarTab";

export default function AdminAttendance() {
  const [tab, setTab] = useState("records");

  return (
    <div className="space-y-6" data-testid="admin-attendance-page">
      <h1 className="font-heading text-3xl font-extrabold tracking-tight">Attendance</h1>

      <div className="flex gap-2 flex-wrap">
        {[["records", "Daily records"], ["calendar", "Calendar"], ["regs", "Regularizations"], ["holidays", "Holidays"], ["shifts", "Shifts"]].map(([k, label]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`attendance-tab-${k}`}
            className={`px-5 py-2.5 rounded-full text-sm font-bold transition-colors duration-200 ${tab === k ? "bg-secondary text-white" : "bg-white border border-stone-200 text-stone-600 hover:bg-stone-50"}`}>{label}</button>
        ))}
      </div>

      {tab === "records" && <RecordsTab />}
      {tab === "calendar" && <CalendarTab />}
      {tab === "regs" && <RegularizationsTab />}
      {tab === "holidays" && <HolidaysTab />}
      {tab === "shifts" && <ShiftsTab />}
    </div>
  );
}
